import React from 'react';
import logoMark from '../assets/logo_mark.png';

export const DEFAULT_COMPANY = {
  name: 'Khayyat Al-Babji Lil-Sayyidat',
  nameAr: 'خياط البابجي للسيدات',
  proprietor: 'QEZAR',
  address: 'Kuwait - Darwaza Abdul Razzak, Mahad Al-Deeni Street, Al-Mailam Bldg. - Basement, Behind Tawari Complex - Shop No. 2',
  addressAr: 'الكويت - دروازة عبدالرزاق، شارع معهد الديني، عمارة الميلم - السرداب، خلف مجمع الطوارئ - محل رقم ٢',
  phone: 'QEZAR: 97636444 · FIROZ: 55753000 · MOIZ: 51516617',
  email: 'info@khayyatalbabji.com',
  website: 'khayyatalbabji.com',
  taxNumber: '',
  currency: 'KWD',
};

const BLUE = '#1E3A8A';

export default function PrintHeader({ company }) {
  const c = { ...DEFAULT_COMPANY, ...(company || {}) };
  const phones = (c.phone || '').split('·').map((p) => p.trim()).filter(Boolean);
  return (
    <div className="text-center relative" style={{ color: BLUE }}>
      <img src={logoMark} alt="logo" className="absolute left-0 top-0 w-24 h-24 object-contain" data-testid="print-logo" />
      <div className="px-24">
        <p className="font-arabic-display" dir="rtl" style={{ fontSize: 44, lineHeight: 1.5, unicodeBidi: 'isolate' }} data-testid="print-company-name-ar">
          {c.nameAr}
        </p>
        <p className="font-heading font-extrabold tracking-wide text-2xl uppercase mt-2" data-testid="print-company-name-en">{c.name}</p>
        {c.proprietor && (
          <span className="inline-block mt-2 px-6 py-1 rounded-full text-white text-sm font-bold italic tracking-wider" style={{ backgroundColor: BLUE }}>
            Prop.: {c.proprietor}
          </span>
        )}
        <div className="flex justify-center gap-6 mt-2.5 text-[15px] font-bold num flex-wrap">
          {phones.map((p) => <span key={p} dir="ltr">{p}</span>)}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-8 items-start mt-3 text-left" style={{ color: BLUE }}>
        <p className="text-[13px] leading-snug">{c.address}</p>
        <p className="text-right font-arabic text-[16px] leading-snug" dir="rtl">{c.addressAr}</p>
      </div>
      <div className="flex justify-center gap-3 text-[13px] mt-1.5 font-medium">
        {c.website && <span>{c.website}</span>}
        {c.email && <span>· {c.email}</span>}
        {c.taxNumber && <span>· TRN: {c.taxNumber}</span>}
      </div>
      <div className="mt-3 border-t-2" style={{ borderColor: BLUE }} />
      <div className="mt-[3px] border-t" style={{ borderColor: BLUE }} />
    </div>
  );
}

export function TitlePill({ en, ar, number, date }) {
  return (
    <div className="flex items-center justify-between my-5" style={{ color: BLUE }}>
      <div className="text-sm w-40">
        <p className="font-semibold">
          <span>Date</span>
          <span className="mx-1">/</span>
          <span className="font-arabic" style={{ unicodeBidi: 'isolate' }} dir="rtl">التاريخ</span>
        </p>
        <p className="num text-[15px] mt-1" dir="ltr" data-testid="print-doc-date">{date}</p>
      </div>
      <div className="px-8 py-2 rounded-full border-2 text-center" style={{ borderColor: BLUE }}>
        <span className="font-arabic text-2xl leading-none align-middle" dir="rtl" style={{ unicodeBidi: 'isolate' }}>{ar}</span>
        <span className="mx-3 opacity-40">·</span>
        <span className="font-heading font-bold text-base uppercase tracking-wide align-middle">{en}</span>
      </div>
      <div className="text-sm w-40 text-right">
        <p className="font-semibold">No.</p>
        <p className="font-mono font-bold text-red-600 text-base mt-1" data-testid="print-doc-number">{number}</p>
      </div>
    </div>
  );
}
